import { createTheme } from '@mui/material/styles';

/** Matches mobile walnut palette (quiet, grounded). */
const theme = createTheme({
  palette: {
    primary: {
      main: '#4A3428',
      dark: '#3A281F',
      light: '#8B6F5C',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#8B6F5C',
      contrastText: '#FFFFFF',
    },
    background: {
      default: '#F0EFED',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#2A221C',
      secondary: '#6E635A',
    },
    divider: '#DDD6CF',
    success: {
      main: '#5A7A62',
    },
    warning: {
      main: '#A67C42',
    },
    error: {
      main: '#A85A4A',
    },
  },
  typography: {
    fontFamily: '"DM Sans", "Helvetica", "Arial", sans-serif',
    h1: { fontFamily: '"Literata", Georgia, serif', fontWeight: 700 },
    h2: { fontFamily: '"Literata", Georgia, serif', fontWeight: 600 },
    h3: { fontFamily: '"Literata", Georgia, serif', fontWeight: 600 },
    h4: { fontFamily: '"Literata", Georgia, serif', fontWeight: 600 },
    h5: { fontFamily: '"Literata", Georgia, serif', fontWeight: 600 },
    h6: { fontFamily: '"Literata", Georgia, serif', fontWeight: 600 },
    button: { textTransform: 'none', fontWeight: 600 },
  },
  shape: {
    borderRadius: 12,
  },
  spacing: (factor) => `${0.25 * factor}rem`,
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: '#F0EFED',
          color: '#2A221C',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          boxShadow: '0 1px 0 rgba(74, 52, 40, 0.06), 0 8px 24px rgba(42, 34, 28, 0.06)',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
        containedPrimary: {
          boxShadow: 'none',
          '&:hover': { boxShadow: 'none' },
        },
      },
    },
  },
});

export default theme;
